import { operations } from "../types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

type attachDocumentOperation = operations["attachDocument"];
type attachContractDocumentOperation = operations["attachContractDocument"];
type attachOfferDocumentOperation = operations["attachOfferDocument"];
type uploadDocOperation = operations["uploadDoc"];
type deleteDocumentOperation = operations["deleteDocument"];
type deleteContractDocumentOperation = operations["deleteContractDocument"];
type deleteOfferDocumentOperation = operations["deleteOfferDocument"];

/**
 * Загрузить файл заявки (доступно для CUSTOMER, OPERATOR)
 */
export const uploadBidFile = (
  { requestId }: attachDocumentOperation["parameters"]["path"],
  fileIds: attachDocumentOperation["requestBody"]["content"]["application/json"]
): Promise<attachDocumentOperation["responses"]["200"]["headers"]> => {
  return api.put(ENDPOINTS.uploadBidFile(requestId), fileIds);
};

/**
 * Загрузить файл договора (доступно для CUSTOMER, OPERATOR)
 */
export const uploadContractFile = (
  { contractId }: attachContractDocumentOperation["parameters"]["path"],
  fileId: attachContractDocumentOperation["requestBody"]["content"]["application/json"]
): Promise<attachContractDocumentOperation["responses"]["200"]["headers"]> => {
  return api.put(ENDPOINTS.uploadContractFile(contractId), JSON.stringify(fileId));
};

/**
 * Удалить файл договора (доступно для CUSTOMER, OPERATOR)
 */
export const removeContractFile = ({
  contractId,
  documentId,
}: deleteContractDocumentOperation["parameters"]["path"]): Promise<
  deleteContractDocumentOperation["responses"]["200"]["headers"]
> => {
  return api.del(ENDPOINTS.removeContractFile(contractId, documentId));
};

/**
 * Удалить файл заявки (доступно для CUSTOMER, OPERATOR)
 */
export const removeBidFile = ({
  documentId,
  requestId,
}: deleteDocumentOperation["parameters"]["path"]): Promise<deleteDocumentOperation["responses"]["200"]["headers"]> => {
  return api.del(ENDPOINTS.removeBidFile({ documentId, requestId }));
};

/**
 * Загрузить файл предложения компании (доступно для OPERATOR)
 */
export const uploadCompanyOfferFile = (
  { id }: attachOfferDocumentOperation["parameters"]["path"],
  fileId: attachOfferDocumentOperation["requestBody"]["content"]["application/json"]
): Promise<attachOfferDocumentOperation["responses"]["200"]["headers"]> => {
  return api.put(ENDPOINTS.uploadCompanyFile(id), JSON.stringify(fileId));
};

/**
 * Удалить файл предложения компании (доступно для OPERATOR)
 */
export const removeCompanyOfferFile = ({
  documentId,
  id,
}: deleteOfferDocumentOperation["parameters"]["path"]): Promise<
  deleteOfferDocumentOperation["responses"]["200"]["headers"]
> => {
  return api.del(ENDPOINTS.removeCompanyFile({ id, documentId }));
};

/**
 * Загрузить файл (доступно для CUSTOMER, OPERATOR)
 */
export const uploadFile = (
  formData: uploadDocOperation["parameters"]["query"]
): Promise<uploadDocOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.post(ENDPOINTS.uploadDoc(), formData, {
    contentType: "multipart/form-data",
  });
};
